var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 58 59"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#7B4EF8",
    d: "M55.544 26.294 43.959 34.77a2.8 2.8 0 0 0-1.012 3.123l4.403 13.63a3.44 3.44 0 0 1-1.26 3.84 3.43 3.43 0 0 1-4.038-.02L30.66 46.948a2.79 2.79 0 0 0-3.31 0l-11.392 8.396a3.428 3.428 0 0 1-5.312-1.686 3.44 3.44 0 0 1 0-2.134l4.417-13.63a2.8 2.8 0 0 0-1.012-3.123L2.466 26.294a3.434 3.434 0 0 1 2.024-6.205h14.258a2.79 2.79 0 0 0 2.661-1.942l4.334-13.52a3.43 3.43 0 0 1 3.265-2.383 3.43 3.43 0 0 1 3.265 2.382l4.333 13.52a2.8 2.8 0 0 0 2.662 1.943h14.258a3.43 3.43 0 0 1 3.258 2.368 3.44 3.44 0 0 1-1.234 3.837z"
  })));
};
export default SvgStar;